import React, { FC, useState, useEffect, memo } from "../../../../lib/teact/teact";
import LotCheckBox from "../../ui/lotCheckBox";
import { getDateString, getDateTimeString, secondsToDate } from "../../utils/DateTimeUtils";

type OwnProps = {
    dataItem: any;
    inSelectMode: boolean;
    selected: boolean;
    onClick: (dataItem: any) => void;
}

const MessageItem: FC<OwnProps> = ({
    dataItem,
    inSelectMode,
    selected,
    onClick,
}) => {
    const isInbox = dataItem.boxId == 1
    const date = secondsToDate(dataItem.date / 1000)
    return (
        <div className=" list-item" onClick={() => onClick(dataItem)}>
            <div className=" tele-message-card">
                <div className={isInbox ? "body-container" : "body-container outbox"}>
                    <div style="width:90%">
                        <div className={isInbox ? "tele-message-body-inbox" : "tele-message-body-outbox"}>
                            {dataItem.body}
                        </div>
                        <div className="message-date">{getDateTimeString(date)}</div>
                        <div style="height: 5px;"></div>
                    </div>

                </div>
            </div>
            {inSelectMode && <LotCheckBox checked={selected} />}
        </div>
    )
}

export default memo(MessageItem)